module.exports = __webpack_public_path__ + "static/map_ita-459cef879ba7336c67405b38f02d6f89.png";